'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CalendarContainer = styled__default.default.div `
  max-width: ${({ theme }) => theme.designTokens.dateInputOverlayMaxWidth};
  padding: ${({ theme }) => theme.designTokens.dateInputOverlayPaddingY}
    ${({ theme }) => theme.designTokens.dateInputOverlayPaddingX};
`;
const Styled = {
    CalendarContainer,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
